import styled from 'styled-components';

export const Pdf = styled('canvas')`
  display: block;
  width: 100%;

  @media(min-width: 768px){

  }
`